


























































































































































































































import Vue from 'vue'
import UpdatePwdDialog from './components/UpdatePwdDialog.vue'
import UpdateTenantInfoDialog from './components/UpdateTenantInfo.vue'
import TenantInfo from './components/TenantInfo.vue'
import SubAccountSet from './components/SubAccountSet.vue'
import moment from 'moment'
import dayjs from 'dayjs'
import { UserServiceProxy } from '@/service-proxies/app-v2/user.service-proxies'
import { WxQrCodeManageServiceProxy } from '@/service-proxies/app-v2/mp.service-proxies'
import { putFilePOST } from '@/api/api'
import { mapMutations, mapGetters } from 'vuex'
import { isCellphoneNo } from '@/utils/validate'
import { getUserInfo } from '@/utils/auth'
import { getLocalStorage, setLocalStorage } from '@/utils/storage'
import vueQr from 'vue-qr'
import { from } from 'node_modules/rxjs'
const userServiceProxy = new UserServiceProxy()
const wxQrCodeManageServiceProxy = new WxQrCodeManageServiceProxy()

export default Vue.extend({
  name: 'Personal',
  components: { UpdatePwdDialog, SubAccountSet, UpdateTenantInfoDialog, vueQr, TenantInfo },
  data() {
    return {
      personalMenus: [
        {
          label: 'page_personal_tenant_info',
          value: 'tenantInfo'
        },
        {
          label: 'page_personal_base_info',
          value: 'basicInfo'
        },
        {
          label: 'page_personal_account_set',
          value: 'accountSet'
        },
        {
          label: 'page_personal_sub_account_set',
          value: 'subAccountSet'
        }
      ],
      avatarLoading: false,
      imageUrl: '',
      selectedMenu: ['tenantInfo'],
      currentMenuItem: {} as any,
      showPwdDialog: false,
      showTenantInfoDialog: false,
      form: this.$form.createForm(this),
      userInfo: {} as any,
      uploadFileUrl: '',
      updateUserLoading: false,
      updatingTenantCode: false,
      tenantCode: '',
      tenantId: '',
      qrVisable: false,
      ticket: '',
      timer: null,
      visableBtn: ''
    }
  },
  computed: {
    ...mapGetters(['avatar'])
  },
  watch: {
    avatar: {
      handler(val) {
        // 针对一开始进入页面，头像有延迟的问题，先从store里获取
        this.imageUrl = val
      },
      immediate: true
    },
    selectedMenu: {
      handler(val) {
        this.currentMenuItem = val.length
          ? this.personalMenus.find((item) => item.value === val[0])
          : {}
        if (val[0] === 'basicInfo') {
          this.updateUserLoading = false
          this.initialUserForm()
        }
      },
      immediate: true
    },
    userInfo: {
      handler() {
        // 用户信息更新，立即更新vuex里存储的用户信息以及localstorage里的存储
        const _: any = this
        let userInfo = getUserInfo()
        let newUserInfo = Object.assign({}, userInfo, this.userInfo)
        _.SET_USER(newUserInfo)
      },
      deep: true
    }
  },
  created() {
    this.getUserInfo()
    this.tenantCode = getLocalStorage('TENANT')['tenantCode']
  },
  mounted: function () {
    let _this = this
    _this.bundlingMp()
    _this.timer = setInterval(function () {
      _this.bundlingMp()
    }, 3000)
  },
  beforeDestroy() {
    let _this = this
    if (_this.timer) {
      clearInterval(_this.timer)
      _this.timer = null
    }
  },
  methods: {
    ...mapMutations('user', ['SET_USER']),
    getUserInfo() {
      // 获取用户详情
      userServiceProxy.info().then((res) => {
        // console.log('用户详情：', res.data)
        this.userInfo = res.data as any
        this.imageUrl = this.userInfo.avatar
        this.userInfo.birthday = this.userInfo.birthday
          ? moment(this.userInfo.birthday, 'YYYY-MM-DD')
          : ''
        this.initialUserForm()
        this.tenantId = this.userInfo.tenantId
      })
    },
    // 表单数据绑定
    initialUserForm() {
      if (!this.userInfo || JSON.stringify(this.userInfo) === '{}') {
        return
      }
      const { name, sex, phone, email, birthday } = this.userInfo
      this.form = this.$form.createForm(this, {
        mapPropsToFields: () => {
          let fields = {
            name: this.$form.createFormField({
              value: name
            }),
            sex: this.$form.createFormField({
              value: sex
            }),
            phone: this.$form.createFormField({
              value: phone
            }),
            email: this.$form.createFormField({
              value: email
            })
          }
          // 针对日期传入空默认值时会报错
          if (birthday) {
            Object.assign(fields, {
              birthday: this.$form.createFormField({
                value: birthday
              })
            })
          }
          return fields
        }
      })
    },
    validatePhone(rule: any, value: any, callback: any) {
      if (!value) {
        callback()
      }
      if (!isCellphoneNo(value)) {
        callback(this.$t('page_personal_phone_valid_tip'))
      }
      callback()
    },
    validateEmail(rule: any, value: any, callback: any) {
      let reg = /^\w+@[a-zA-Z0-9]{2,10}(?:\.[a-z]{2,4}){1,3}$/
      if (value && !reg.test(value)) {
        callback(this.$t('page_personal_email_valid_tip'))
      }
      callback()
    },
    // 上传头像前校验
    beforeUpload(file: any) {
      const isJpgOrPng =
        file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error(this.$t('page_personal_upload_tip'))
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error(this.$t('page_personal_upload_tip2'))
      }
      return isJpgOrPng && isLt2M
    },
    // 上传头像到华为云
    uploadImage(file: any) {
      this.avatarLoading = true
      const valid = this.beforeUpload(file.file)
      if (!valid) {
        this.avatarLoading = false
        return
      }
      const formData = new FormData()
      formData.append('file', file.file)
      putFilePOST(formData)
        .then((res: any) => {
          if (res) {
            this.imageUrl = res.data.data.link
            this.saveAvatar() // 保存新头像
          }
        })
        .finally(() => {
          this.avatarLoading = false
        })
    },
    // 保存头像
    saveAvatar() {
      let { id, status, tenantId, roleId, deptId } = this.userInfo
      let params = Object.assign(
        {},
        { id, status, tenantId, roleId, deptId },
        { avatar: this.imageUrl }
      ) as any
      userServiceProxy.update(params).then(
        (res: any) => {
          // console.log('更新头像：', res)
          if (res) {
            this.getUserInfo()
            this.$message.success(this.$t('page_personal_headimg_success'))
          }
        },
        (err: any) => {
          this.$message.error(this.$t('page_personal_headimg_fail'))
        }
      )
    },
    changeMenu(item: any) {
      this.selectedMenu = item.keyPath
    },
    openUpdatePwdDialog() {
      this.showPwdDialog = true
    },
    openUpdateTenantInfoDialog() {
      this.showTenantInfoDialog = true
    },
    closeTenantInfoDialog(e: any) {
      this.showTenantInfoDialog = false
      if (e !== undefined) {
        console.log(e)
        this.tenantCode = e
        setLocalStorage('TENANT', { tenantCode: this.tenantCode })
      }
    },
    // 保存修改的用户信息
    handleSubmit(e: any) {
      e.preventDefault()
      this.updateUserLoading = true
      this.form.validateFieldsAndScroll((err: any, values: any) => {
        if (err) {
          this.updateUserLoading = false
          return
        }
        // 日期格式化
        values.birthday = values.birthday
          ? dayjs(values.birthday).format('YYYY-MM-DD') + ' 00:00:00'
          : ''
        // 过滤需要回传的参数
        let { id, status, tenantId, roleId, deptId } = this.userInfo
        let params = Object.assign({}, { id, status, tenantId, roleId, deptId }, values)
        // console.log('update user:', params)
        userServiceProxy
          .update(params)
          .then((res: any) => {
            // console.log('更新用户结果：', res)
            if (res) {
              this.$message.success(res.msg)
              this.getUserInfo()
            }
          })
          .finally(() => {
            this.updateUserLoading = false
          })
      })
    },
    async createTicket() {
      let param: any = {
        appId: '',
        expireSeconds: 1000,
        isTemp: true,
        sceneStr: null
      }
      let res = await wxQrCodeManageServiceProxy.createTicket(param)
      this.ticket = res.data.url
      console.log(777, res)
    },
    async bundlingMp() {
      let res = await wxQrCodeManageServiceProxy.bundlingMp()
      if (res.data) {
        this.visableBtn = res.data.id
        this.qrVisable = false
      } else {
        this.visableBtn = ''
      }
      console.log(9999, this.visableBtn)
    },
    async unbundlingMp() {
      await wxQrCodeManageServiceProxy.unbundlingMp().then((res) => {
        if (res) this.$message.success('解绑成功')
      })
    },
    openQr() {
      this.createTicket()
      this.qrVisable = true
    },
    closeQr() {
      this.qrVisable = false
    }
  }
})
